import EmailCollector from '../contract/LaunchpadEmailsCollectorContract.json'
import {useContract} from "../Standard/hooks/useCommonContracts";
import {getEmailCollectorAddress} from '../utils/getAddress'

export const useEmailCollectorContract = () => {
  const abi = EmailCollector.abi;
  return useContract(abi, getEmailCollectorAddress())
}